import { COLUMNS, PENDING_CELL_CLASSNAME } from './constants';

import { CustomMenuIcon, CustomColumnMenu, DATAGRID_COMMON_STYLE } from '@commons/utils/dataGrid';

/**
 * Pure-CSS saving indicator for cells with an in-flight upsert (COR-1576): the class is
 * toggled through getCellClassName, so no column rebuild nor cell renderer change is needed.
 */
const PENDING_CELL_STYLE = {
  [`& .${PENDING_CELL_CLASSNAME}`]: {
    position: 'relative',
    pointerEvents: 'none',
    '& > *': {
      opacity: 0.4,
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 'calc(50% - 6px)',
      right: '4px',
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      border: '2px solid rgba(0, 0, 0, 0.35)',
      borderTopColor: 'transparent',
      animation: 'sales-planning-pending-rotate 0.8s linear infinite',
    },
  },
  '@keyframes sales-planning-pending-rotate': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },
};

// See https://mui.com/x/api/data-grid/data-grid-pro/ for reference
const DATAGRID_OTHER_PROPS = {
  autosizeOnMount: true,
  disableColumnResize: false,
  disableColumnSelector: true,
  disableDensitySelector: true,
  disableRowSelectionOnClick: true,
  ignoreDiacritics: true,
  showCellVerticalBorder: false,
  showColumnVerticalBorder: false,
};

const DATAGRID_INITIAL_STATE = {
  pinnedColumns: {
    left: [COLUMNS.CHECKBOX, COLUMNS.NAME, COLUMNS.CATEGORY],
    right: [COLUMNS.TOTAL],
  },
  columns: {
    columnVisibilityModel: {
      sku: false,
    },
  },
  sorting: {
    sortModel: [
      { field: COLUMNS.CATEGORY, sort: 'asc' },
      { field: COLUMNS.NAME, sort: 'asc' },
    ],
  },
  filter: {
    filterModel: {
      items: [
        { columnField: COLUMNS.SKU, operatorValue: 'contains', value: '' },
        { columnField: COLUMNS.NAME, operatorValue: 'contains', value: '' },
      ],
    },
  },
};

export const DATAGRID_SLOTS = {
  columnMenu: (props) => CustomColumnMenu(props, [COLUMNS.NAME, COLUMNS.CATEGORY, COLUMNS.TOTAL]),
  columnMenuIcon: CustomMenuIcon,
};

const DATAGRID_SLOT_PROPS = {
  toolbar: {
    showQuickFilter: true,
    printOptions: { disableToolbarButton: true },
    csvOptions: { disableToolbarButton: true },
  },
};

export const COMMON_DATAGRID_PROPS = {
  initialState: DATAGRID_INITIAL_STATE,
  sx: { ...DATAGRID_COMMON_STYLE, ...PENDING_CELL_STYLE },
  slotProps: DATAGRID_SLOT_PROPS,
  ...DATAGRID_OTHER_PROPS,
};
